interface VideoPreviewProps {
  src: string | null
}

export function VideoPreview({ src }: VideoPreviewProps) {
  if (!src) return null

  return (
    <div className="mt-5 rounded-xl overflow-hidden">
      <video
        src={src}
        controls
        playsInline
        aria-label="Downloaded video preview"
        className="w-full block"
      />
    </div>
  )
}
